import { useQuery } from '@tanstack/react-query'
import { queryKeyStore } from 'src/react_query'

// The app won't auto update (refresh) if it hasn't been open for at least this time
const MINIMUM_APP_UPTIME = 10 * 60_000
// The app won't auto update (refresh) if its build isn't at least 12 hours old
const MINIMUM_APP_AGE = 12 * 60 * 60_000

const getBuildDatetime = () => {
  const buildDatetimeIso = process.env.REACT_APP_BUILD_DATETIME
  const buildDatetime = buildDatetimeIso
    ? new Date(buildDatetimeIso)
    : undefined
  console.log(`Running version ${buildDatetime}`)
  return buildDatetime
}

const buildDatetime = getBuildDatetime()

const useAutoUpdater = () => {
  const uptime = document.timeline.currentTime ?? 0
  // Only consider refreshing if the app is open for more than 10 minutes.
  // This is here to prevent an infinite loop.
  const isOverMinimumUptime =
    typeof uptime === 'number' ? uptime > MINIMUM_APP_UPTIME : false

  const isReallyOutdated = isBuildReallyOutdated()
  const isEnabled = isOverMinimumUptime && isReallyOutdated

  const dateQuery = useQuery({
    ...queryKeyStore.deploymentInfo.detail,
    enabled: isEnabled,
  })

  if (!isEnabled || !dateQuery.data) {
    return
  }

  const isThereANewerBuild =
    dateQuery.data.datetime.getTime() - (buildDatetime?.getTime() ?? 0) > 0
  if (isThereANewerBuild) {
    window.location.reload()
  }
}

const isBuildReallyOutdated = () => {
  const now = new Date()
  if (!buildDatetime) {
    return false
  }
  return now.getTime() - buildDatetime.getTime() > MINIMUM_APP_AGE
}

export default useAutoUpdater
